import React from 'react';
import PropTypes from 'prop-types';
import { Radio } from 'antd';
import './RDRadio.scss';

const RDRadio = ({ selectedKey, onChange, options, disabled, radioSize, radioStyle }) => (
  <Radio.Group
    onChange={onChange}
    options={options}
    value={selectedKey}
    disabled={disabled}
    size={radioSize}
    style={radioStyle}
  />
);

RDRadio.defaultProps = {
  selectedKey: '',
  onChange: () => {},
  disabled: false,
  radioSize: 'middle',
  radioStyle: {},
};

RDRadio.propTypes = {
  /** Currently selected radio */
  selectedKey: PropTypes.string,
  /** The callback function that is triggered when the state changes */
  onChange: PropTypes.func,
  /** Radio options */
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
      disabled: PropTypes.bool,
    }),
  ).isRequired,
  /** Disable all radio buttons */
  disabled: PropTypes.bool,
  /** The size of radio button style - large | middle | small */
  radioSize: PropTypes.string,
  /** Radio styles */
  radioStyle: PropTypes.shape({}),
};

export default RDRadio;
